import {
  createRouter,
  createWebHashHistory,
  createWebHistory
} from 'vue-router'
import login from '@/views/login/login.vue'
import main from '@/views/main.vue'


//新的路由
//核验业务申请
import orderSubMit from '@/views/page/orderSubMit.vue'
//核验业务结果列表
import orderList from '@/views/page/orderList.vue'
//缴费充值
import payBills from '@/views/page/payBills.vue'
//财务管理
import payManagement from '@/views/page/payManagement.vue'
//财务明细
import payDetails from '@/views/page/payDetails.vue'
//账户信息
import userInfo from '@/views/page/userInfo.vue'
//密钥管理
import userApiManagement from '@/views/page/userApiManagement.vue'
//子账号管理
import userSub from '@/views/page/userSub.vue'
//数据中心
import dataCenter from '@/views/page/dataCenter.vue'
const routes = [{
    path: '/',
    name: 'main',
    component: main,
    children: [
      //下面开始是适用于子账号操作的相关路由
      //账户信息
      {
        path:'/userInfo',
        name: 'userInfo',
        component: userInfo
      },
      //密钥管理
      {
        path:'/userApiManagement',
        name: 'userApiManagement',
        component: userApiManagement
      },
      //子账号管理  
      {
        path:'/userSub',
        name: 'userSub',
        component: userSub
      },


      //核验业务申请
      {
        path:'/orderSubMit',
        name: 'orderSubMit',
        component: orderSubMit
      },
      //核验业务结果列表
      {
        path:'/orderList',
        name: 'orderList',
        component: orderList
      },
      //财务相关路由
      //财务管理
      {
        path:'/payManagement',
        name: 'payManagement',
        component: payManagement
      },
      //缴费充值
      {
        path:'/payBills',
        name: 'payBills',
        component: payBills
      },
      //财务明细
      {
        path:'/payDetails',
        name: 'payDetails',
        component: payDetails
      },
      //数据中心
      {
        path:'/dataCenter',
        name: 'dataCenter',
        component: dataCenter
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
]

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes
// })
const router = createRouter({
  // 使用createWebHistory创建历史模式的路由
  // history: createWebHistory(),
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return {
      top: 0,
      behavior: 'auto'
    }; // behavior: 'smooth' 为平滑滚动
  },
});

// 定义白名单，添加 xq 对应的路径
const whiteList = ['/login'];

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (whiteList.includes(to.path)) {
    // 如果在白名单中，直接放行
    // window.topkai()
    next();
  } else if (!token) {
    // 不在白名单且没有 token，重定向到登录页
    next('/login');

  } else {
    // window.topguan()
    // 有 token，正常访问
    next();
  }
});

export default router
